import React from 'react';
import { PromiseToPayWithUser } from '@dill/dill-shared';
import PromiseToPaysTable from '../../customers/CustomerDetails/SupplierCustomerPromiseToPays/PromiseToPaysTable';

interface SupplierPromiseToPaysTableProps {
  promiseToPays: PromiseToPayWithUser[];
  sortOptions: { sortOrder: 'asc' | 'desc'; sortBy: string };
  onSortChange: (sortOptions: { sortOrder: 'asc' | 'desc'; sortBy: string }) => void;
  onRowClick: (promiseToPay: PromiseToPayWithUser) => void;
  onDelete: (promiseToPayId: string) => void;
  onCancel: (promiseToPayId: string) => void;
  onEdit: (promiseToPay: PromiseToPayWithUser) => void;
  toolbarRight?: React.ReactNode;
  searchValue?: string;
  onSearch?: (value: string) => void;
}

function SupplierPromiseToPaysTable({
  promiseToPays,
  sortOptions,
  onSortChange,
  onRowClick,
  onDelete,
  onCancel,
  onEdit,
  toolbarRight,
  searchValue,
  onSearch,
}: SupplierPromiseToPaysTableProps) {
  return (
    <PromiseToPaysTable
      promiseToPays={promiseToPays}
      sortOptions={sortOptions}
      onSortChange={onSortChange}
      onRowClick={onRowClick}
      onDelete={onDelete}
      onCancel={onCancel}
      onEdit={onEdit}
      showBuyerColumn={true}
      toolbarRight={toolbarRight}
      searchValue={searchValue}
      onSearch={onSearch}
    />
  );
}

export default SupplierPromiseToPaysTable;
